var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7E8083",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M17.144 2.992h-3.841C13.11 1.31 11.697 0 9.985 0S6.86 1.31 6.668 2.992H2.827c-1.555 0-2.82 1.28-2.82 2.853v.146c0 1.202.74 2.23 1.783 2.65v13.477c0 1.573 1.264 2.852 2.819 2.852h10.753c1.555 0 2.82-1.28 2.82-2.852V8.64a2.855 2.855 0 0 0 1.78-2.65v-.146c0-1.573-1.264-2.853-2.818-2.853zM9.985 1.353c.974 0 1.787.706 1.967 1.639H8.019a2.013 2.013 0 0 1 1.966-1.639zm6.86 20.765c0 .827-.666 1.5-1.483 1.5H4.608a1.493 1.493 0 0 1-1.482-1.5V8.844h13.718v13.274zm1.78-16.127c0 .827-.664 1.5-1.481 1.5H2.827a1.493 1.493 0 0 1-1.482-1.5v-.146c0-.828.665-1.5 1.482-1.5h14.317c.817 0 1.482.672 1.482 1.5v.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.401 21.887c.37 0 .669-.303.669-.676v-7.617c0-.373-.3-.676-.669-.676a.673.673 0 0 0-.668.676v7.617c0 .373.299.676.668.676zM9.985 21.887c.37 0 .669-.303.669-.676v-7.617c0-.373-.3-.676-.669-.676a.673.673 0 0 0-.668.676v7.617c0 .373.3.676.668.676zM13.57 21.887c.369 0 .668-.303.668-.676v-7.617c0-.373-.3-.676-.668-.676a.673.673 0 0 0-.669.676v7.617c0 .373.3.676.669.676z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.0f902beceffe4de49ac90a28007f1983.svg";
export { ForwardRef as ReactComponent };